import { useEffect, useRef } from 'react';
import { useSession } from '../store/session';
import MessageBubble from './MessageBubble';
import Composer from './Composer';
import { motion } from 'motion/react';

export default function Chat() {
  const messages = useSession(s => s.messages);
  const theme = useSession(s => s.settings.theme);
  const scroller = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scroller.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages]);

  const isLight = theme === 'light';

  return (
    <div className="chat" style={{ position: 'relative', background: isLight ? '#F2F3F5' : '#111111', overflow: 'hidden' }}>
      {/* Background Animated Logo */}
      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none', zIndex: 0 }}>
        <motion.img
          src={isLight ? "https://theparadoxuniverse.b-cdn.net/%21File%20Organization/%21_Universal_Imagery/LOGOS/Logo_BLK_Transparent.png" : "https://theparadoxuniverse.b-cdn.net/%21File%20Organization/%21_Universal_Imagery/LOGOS/Logo_White_Transparent.png"}
          alt=""
          animate={{
            scale: [1, 1.05, 1],
            rotate: [0, 360],
          }}
          transition={{
            scale: { duration: 6, ease: "easeInOut", repeat: Infinity },
            rotate: { duration: 60, ease: "linear", repeat: Infinity }
          }}
          style={{ width: '40vw', minWidth: '300px', maxWidth: '600px', opacity: isLight ? 0.4 : 0.2 }}
        />
      </div>

      {/* Glassmorphism Overlay */}
      <div style={{ position: 'absolute', inset: 0, background: isLight ? 'rgba(242, 243, 245, 0.4)' : 'rgba(17, 17, 17, 0.4)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', pointerEvents: 'none', zIndex: 1 }}></div>

      <div className="chat__scroll" ref={scroller} style={{ position: 'relative', zIndex: 2 }}>
        {messages.length === 0 && (
          <div className="chat__empty" style={{ background: 'var(--bg-card)', padding: '16px', borderRadius: '16px', border: '1px solid var(--line)', backdropFilter: 'blur(12px)' }}>
            describe a shot, attach a reference, or hit record. the director takes it from there.
          </div>
        )}
        {messages.map(m => <MessageBubble key={m.id} message={m} />)}
      </div>
      <div style={{ position: 'relative', zIndex: 3, width: '100%', boxSizing: 'border-box', minWidth: 0 }}>
        <Composer />
      </div>
    </div>
  );
}
